import { useState, useRef, useEffect } from 'react';
import styles from './FloorplanFilters.module.css';
import burst from './assets/burst.svg';

export default function FloorplanFilters({
    filters,
    onFilterChange,
    onClearFilters,
    availableHomeTypes = [],
    availableBeds = []
}) {
    const [openDropdown, setOpenDropdown] = useState(null);
    const dropdownRefs = {
        homeType: useRef(null),
        beds: useRef(null)
    };

    const handleChange = (filterName, value) => {
        onFilterChange(filterName, value);
        setOpenDropdown(null);
    };

    const toggleDropdown = (dropdownName) => {
        setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            const clickedOutside = Object.values(dropdownRefs).every(
                ref => ref.current && !ref.current.contains(event.target)
            );
            if (clickedOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const CustomDropdown = ({ name, label, options, value, formatOption }) => (
        <div className={styles.customDropdown} ref={dropdownRefs[name]}>
            <div
                className={styles.dropdownHeader}
                onClick={() => toggleDropdown(name)}
            >
                <span>{value || label}</span>
                <img
                    src={burst}
                    alt="dropdown icon"
                    className={`${styles.dropdownIcon} ${openDropdown === name ? styles.spinning : ''}`}
                />
            </div>
            {openDropdown === name && (
                <div className={styles.dropdownList}>
                    <div
                        className={styles.dropdownItem}
                        onClick={() => handleChange(name, '')}
                    >
                        {label}
                    </div>
                    {options.map((option) => (
                        <div
                            key={option}
                            className={styles.dropdownItem}
                            onClick={() => handleChange(name, option)}
                        >
                            {formatOption ? formatOption(option) : option}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    return (
        <div className={styles.filtersContainer}>
            <h1 className={styles.title}>Choose a Floor Plan</h1>

            <div className={styles.filtersRow}>
                <div className={styles.filterGroup}>
                    <CustomDropdown
                        name="homeType"
                        label="Home Type"
                        options={availableHomeTypes}
                        value={filters.homeType}
                    />
                </div>

                <div className={styles.filterGroup}>
                    <CustomDropdown
                        name="beds"
                        label="Beds"
                        options={availableBeds}
                        value={filters.beds}
                        formatOption={(beds) => `${beds}+`}
                    />
                </div>

                <button
                    className={styles.clearButton}
                    onClick={onClearFilters}
                >
                    Clear Filters
                </button>
            </div>
        </div>
    );
}
